import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Product, Shipping } from '@vestiaire/api-sdk-angular';
import { SizeGuideModalComponent } from '@app/shared/components/size-guide-modal/size-guide-modal.component';
import { SizeGuide } from '@app/shared/model/interfaces/sizeGuide/sizeGuide';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'vc-product-description-list',
  templateUrl: './product-description-list.component.html',
  styleUrls: ['./product-description-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDescriptionListComponent {
  @Input()
  product: Product;
  @Input()
  shipping: Shipping;
  @Input()
  sizeGuide: SizeGuide;

  @Output()
  openConditionGuideModal = new EventEmitter();

  public hiddenSmDList = true;

  constructor(private dialogService: MatDialog) {}

  get vintage(): boolean {
    return this.product && this.product.tags && this.product.tags.includes('vintage');
  }

  toggleDescriptionList() {
    this.hiddenSmDList = !this.hiddenSmDList;
  }

  conditionGuideModalComponent(): void {
    this.openConditionGuideModal.emit();
  }

  openSizeGuideModal() {
    if (this.sizeGuide && this.sizeGuide.guide.length > 0) {
      this.dialogService.open(SizeGuideModalComponent, {
        maxWidth: 800,
        data: {
          size: this.product.size['size'],
          standard: this.product.size['standard'],
          sizeGuide: this.sizeGuide
        }
      });
    }
  }
}
